export default __webpack_public_path__ + "media/images/icon_file_download-6156b6e920af79cbb9857b8d57875554.svg";